import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { DateTimePipe, FileSizePipe } from '@nimmsta/ng-commons-lib/pipes';
import {
  FirmwareBundle,
  SoftwareArtifact,
  SoftwareArtifactStatus,
} from '@nimmsta/ng-commons-lib/models';
import {
  ButtonHierarchyLevel,
  SoftwareArtifactDownloadButtonComponent,
} from '../software-artifact-download-button.component';
import { TranslatePipe } from '@ngx-translate/core';
import { RouterLink } from '@angular/router';
import { NgClass } from '@angular/common';
import { MarkdownComponent } from 'ngx-markdown';
import { FormsModule } from '@angular/forms';
import { SelectModule } from 'primeng/select';

@Component({
  selector: 'app-software-artifact',
  templateUrl: './software-artifact.component.html',
  styleUrls: ['software-artifact.component.scss', '../software-label.scss'],
  imports: [
    TranslatePipe,
    SoftwareArtifactDownloadButtonComponent,
    RouterLink,
    NgClass,
    MarkdownComponent,
    FileSizePipe,
    DateTimePipe,
    FormsModule,
    SelectModule,
  ],
})
export class SoftwareArtifactComponent implements OnChanges {
  readonly noHardwareVersionOptionValue = '__NO_HARDWARE_VERSION__';

  selectedHardwareVersion?: string;

  @Input() artifact!: SoftwareArtifact;

  @Input() showChangelogAlways = false;

  @Input() isAdmin = false;

  @Input() editable = true;

  @Output() edit = new EventEmitter<void>();

  SoftwareArtifactStatus = SoftwareArtifactStatus;

  ButtonHierarchyLevel = ButtonHierarchyLevel;

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes['artifact']) {
      return;
    }
    this.selectedHardwareVersion = this.hardwareVersionOptions[0];
  }

  get firmwareBundles(): FirmwareBundle[] {
    if (this.artifact.firmwareBundles?.length) {
      return this.artifact.firmwareBundles;
    }
    if (this.artifact.firmwareBundle) {
      return [this.artifact.firmwareBundle];
    }
    return [];
  }

  get hardwareVersionOptions(): string[] {
    return Array.from(
      new Set(
        this.firmwareBundles.map((bundle) =>
          this.getHardwareVersionOptionValue(bundle),
        ),
      ),
    );
  }

  get selectedFirmwareBundle(): FirmwareBundle | undefined {
    const firstOption = this.hardwareVersionOptions[0];
    const selectedHardwareVersion = this.selectedHardwareVersion ?? firstOption;
    return this.firmwareBundles.find(
      (bundle) =>
        this.getHardwareVersionOptionValue(bundle) === selectedHardwareVersion,
    );
  }

  onHardwareVersionChange(selectedHardwareVersion: string): void {
    this.selectedHardwareVersion = selectedHardwareVersion;
  }

  getHardwareVersionOptionValue(bundle: FirmwareBundle): string {
    return bundle.hardwareVersion ?? this.noHardwareVersionOptionValue;
  }
}
